export default "__VITE_ASSET__DlEQLhh$__"